export const CHOICE_TEXT = 'Choose one grade band to complete this section.'
export const LOADING_TEXT = 'Loading training data...'
